import { makeStyles, lighten, darken } from "@material-ui/core";

export const BQSAlertDialogStyle = makeStyles((theme) => ({
    root: {
        minWidth: "640px",
    },
    title: {
        borderBottom: "1px solid #222",
    },
    titletext: {
        fontSize: "16px",
        fontWeight: 500,
    },
    description: {
        padding: "15px",
    },
    btn: {
        color: "white",
        backgroundColor: "#C12631",
        "&:hover": {
            backgroundColor: lighten("#C12631", 0.2),
        },
    },
}));
